export const trailingActivityTableData = {
    keys: [
        "sl_no",
        "display_order",
        "deeming_agency",
        "standard",
        "client",
        "sector",
        "campus",
        "building",
        "activity_description",
        "default_total_devices",
        "test_frequency",
        "code_reference",
        "procedure_id",
        "date_last_performed",
        "next_due_date"
    ],
    config: {
        display_order: {
            isVisible: false,
            label: "DO",
            class: "ref",
            searchKey: "schedules.display_order",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 0
        },
        parent: {
            isVisible: true,
            label: "Parent",
            class: "",
            searchKey: "consultancy_activities.parent",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "consultancy_activities",
            commonSearchKey: "consultancy_activities",
            commonSearchObjectKey: "parent",
            item: 1
        },
        deeming_agency: {
            isVisible: true,
            label: "DA",
            class: "ref",
            searchKey: "deeming_agencies.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "deeming_agency",
            commonSearchKey: "deeming_agencies",
            commonSearchObjectKey: "name",
            item: 2
        },
        year: {
            isVisible: true,
            label: "Year",
            class: "year",
            searchKey: "schedules.year",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 3
        },
        client: {
            isVisible: true,
            label: "Client",
            class: "region",
            searchKey: "clients.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 4
        },
        sector: {
            isVisible: true,
            label: "Sector",
            class: "region",
            searchKey: "sectors.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 5
        },
        standard: {
            isVisible: true,
            label: "Std",
            class: "ref",
            searchKey: "schedules.standard",
            type: "window",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 6
        },
        campus: {
            isVisible: true,
            label: "Campus",
            class: "site",
            searchKey: "campus.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 7
        },
        building: {
            isVisible: true,
            label: "Building",
            class: "build",
            searchKey: "buildings.name",
            type: "object",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 8
        },
        activity_description: {
            isVisible: true,
            label: "Activity",
            class: "activity",
            searchKey: "schedules.activity_description",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 9
        },
        default_total_devices: {
            isVisible: true,
            label: "DC",
            class: "d-count",
            searchKey: "schedules.default_total_devices",
            type: "number",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 10
        },
        test_frequency: {
            isVisible: true,
            label: "Test Frequecy",
            class: "t-freq",
            searchKey: "schedules.test_frequency",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 11
        },
        code_reference: {
            isVisible: true,
            label: "Code Reference",
            class: "code-ref",
            searchKey: "schedules.code_reference",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 12
        },
        procedure_id: {
            isVisible: false,
            label: "Procedure Id",
            class: "p-id",
            searchKey: "schedules.procedure_id",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 13
        },
        date_last_performed: {
            isVisible: true,
            label: "Last Performed",
            class: "l-perform",
            searchKey: "schedules.date_last_performed",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 14
        },
        next_due_date: {
            isVisible: true,
            label: "Next Due Date",
            class: "n-due",
            searchKey: "schedules.next_due_date",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 15
        },
        sl_no: {
            isVisible: true,
            label: "Sl No",
            class: "",
            searchKey: "",
            type: "number",
            hasWildCardSearch: false,
            hasSort: false,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 16
        }
    },
    data: []
};

export const trailingCalenderTableData = {
    keys: [
        "asset",
        "date_last_performed",
        "standard",
        "activity_description",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    config: {
        asset: {
            isVisible: true,
            label: "Asset",
            class: "",
            searchKey: "assets.name",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "assets",
            commonSearchKey: "assets",
            commonSearchObjectKey: "name",
            item: 0
        },
        date_last_performed: {
            isVisible: true,
            label: "Last Performed",
            class: "l-perform",
            searchKey: "schedules.date_last_performed",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 1,
            isMonth: false
        },
        standard: {
            isVisible: true,
            label: "Std",
            class: "ref",
            searchKey: "schedules.standard",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 2,
            isMonth: false
        },
        activity_description: {
            isVisible: true,
            label: "Activity",
            class: "activity",
            searchKey: "schedules.activity_description",
            type: "string",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: true,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            item: 3,
            isMonth: false
        },
        Jan: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 4,
            monthSearchKey: "Jan"
        },
        Feb: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 5,
            monthSearchKey: "Feb"
        },
        Mar: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 6,
            monthSearchKey: "Mar"
        },
        Apr: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 7,
            monthSearchKey: "Apr"
        },
        May: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 8,
            monthSearchKey: "May"
        },
        Jun: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 9,
            monthSearchKey: "Jun"
        },
        Jul: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 10,
            monthSearchKey: "Jul"
        },
        Aug: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 11,
            monthSearchKey: "Aug"
        },
        Sep: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 12,
            monthSearchKey: "Sep"
        },
        Oct: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 13,
            monthSearchKey: "Oct"
        },
        Nov: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 14,
            monthSearchKey: "Nov"
        },
        Dec: {
            isVisible: false,
            label: "",
            class: "",
            searchKey: "",
            type: "date",
            hasWildCardSearch: true,
            hasSort: true,
            hasCommonSearch: false,
            getListTable: "",
            commonSearchKey: "",
            commonSearchObjectKey: "",
            isMonth: true,
            item: 15,
            monthSearchKey: "Dec"
        }
    },
    data: []
};
